/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { StoreAddress } from './StoreAddress';
// @ts-ignore
import {
// @ts-ignore
    StoreAddressFromJSON,
// @ts-ignore
    StoreAddressFromJSONTyped,
// @ts-ignore
    StoreAddressToJSON,
} from './StoreAddress';
// @ts-ignore
import type { StoreOrderPrediction } from './StoreOrderPrediction';
// @ts-ignore
import {
// @ts-ignore
    StoreOrderPredictionFromJSON,
// @ts-ignore
    StoreOrderPredictionFromJSONTyped,
// @ts-ignore
    StoreOrderPredictionToJSON,
} from './StoreOrderPrediction';
// @ts-ignore
import type { StoreReceivingWindow } from './StoreReceivingWindow';
// @ts-ignore
import {
// @ts-ignore
    StoreReceivingWindowFromJSON,
// @ts-ignore
    StoreReceivingWindowFromJSONTyped,
// @ts-ignore
    StoreReceivingWindowToJSON,
} from './StoreReceivingWindow';

/**
 * 
 * @export
 * @interface StoreUpdateRequest
 */
export interface StoreUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    retailerId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    contactCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    contactNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUpdateRequest
     */
    currencyCode?: string;
    /**
     * 
     * @type {Status}
     * @memberof StoreUpdateRequest
     */
    status?: Status;
    /**
     * 
     * @type {Array<StoreAddress>}
     * @memberof StoreUpdateRequest
     */
    addresses: Array<StoreAddress>;
    /**
     * 
     * @type {boolean}
     * @memberof StoreUpdateRequest
     */
    showVat?: boolean;
    /**
     * 
     * @type {Array<StoreReceivingWindow>}
     * @memberof StoreUpdateRequest
     */
    receivingWindows: Array<StoreReceivingWindow>;
    /**
     * 
     * @type {StoreOrderPrediction}
     * @memberof StoreUpdateRequest
     */
    orderPrediction?: StoreOrderPrediction;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof StoreUpdateRequest
     */
    customData?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof StoreUpdateRequest
     */
    dynamicFields?: { [key: string]: string; };
}

/**
 * Check if a given object implements the StoreUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfStoreUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "addresses" in value;
    isInstance = isInstance && "receivingWindows" in value;

    return isInstance;
}

// @ts-ignore
export function StoreUpdateRequestFromJSON(json: any): StoreUpdateRequest {
    return StoreUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'retailerId': !exists(json, 'retailer_id') ? undefined : json['retailer_id'],
        'name': json['name'],
        'email': json['email'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'contactCountryCode': !exists(json, 'contact_country_code') ? undefined : json['contact_country_code'],
        'contactNumber': !exists(json, 'contact_number') ? undefined : json['contact_number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'currencyCode': !exists(json, 'currency_code') ? undefined : json['currency_code'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
        'addresses': ((json['addresses'] as Array<any>).map(StoreAddressFromJSON)),
        'showVat': !exists(json, 'show_vat') ? undefined : json['show_vat'],
        'receivingWindows': ((json['receiving_windows'] as Array<any>).map(StoreReceivingWindowFromJSON)),
        'orderPrediction': !exists(json, 'order_prediction') ? undefined : StoreOrderPredictionFromJSON(json['order_prediction']),
        'customData': !exists(json, 'custom_data') ? undefined : json['custom_data'],
        'dynamicFields': !exists(json, 'dynamic_fields') ? undefined : json['dynamic_fields'],
    };
}

// @ts-ignore
export function StoreUpdateRequestToJSON(value?: StoreUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'retailer_id': value.retailerId,
        'name': value.name,
        'email': value.email,
        'external_code': value.externalCode,
        'contact_country_code': value.contactCountryCode,
        'contact_number': value.contactNumber,
        'description': value.description,
        'currency_code': value.currencyCode,
        'status': StatusToJSON(value.status),
        'addresses': ((value.addresses as Array<any>).map(StoreAddressToJSON)),
        'show_vat': value.showVat,
        'receiving_windows': ((value.receivingWindows as Array<any>).map(StoreReceivingWindowToJSON)),
        'order_prediction': StoreOrderPredictionToJSON(value.orderPrediction),
        'custom_data': value.customData,
        'dynamic_fields': value.dynamicFields,
    };
}

